import React from "react"
import { FaWhatsapp } from "react-icons/fa"
import { supportWhatsAppNumber, supportWhatsAppText } from "config"

export function SidebarHelp() {
  const handleClick = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=${supportWhatsAppNumber}&text=${supportWhatsAppText}`,
      "_blank",
    )
  }

  return (
    <div
      onClick={handleClick}
      style={{
        width: "48px",
        height: "48px",
        backgroundColor: "#ffffff",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",

        // ✨ make it beautiful
        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        transition: "all 0.2s ease",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "scale(1.1)"
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "scale(1)"
      }}
    >
      <FaWhatsapp size={24} color="#25D366" />
    </div>
  )
}
